// extracted by mini-css-extract-plugin
export default {"wrapper":"gnHFo","infoBlocks":"TQuno","block":"L8AGH","icon":"oJXU9","title":"tVpyn","description":"CgaiY"};